import api from "./api";

const officialCampaignService = {
  list(params = {}) {
    return api.get("/official-campaigns", { params });
  },
  show(id) {
    return api.get(`/official-campaigns/${id}`);
  },
  create(data) {
    return api.post("/official-campaigns", data);
  },
  schedule(id, payload = {}) {
    return api.post(`/official-campaigns/${id}/schedule`, payload);
  },
  stats(id) {
    return api.get(`/official-campaigns/${id}/stats`);
  },
  contacts(id, params = {}) {
    return api.get(`/official-campaigns/${id}/contacts`, { params });
  },
  templates(whatsappId) {
    return api.get(`/official-campaigns/templates/${whatsappId}`);
  },
  cancel(id) {
    return api.post(`/official-campaigns/${id}/cancel`);
  },
  restart(id) {
    return api.post(`/official-campaigns/${id}/restart`);
  },
  remove(id) {
    return api.delete(`/official-campaigns/${id}`);
  }
};

export default officialCampaignService;

